import React, { useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { BsFillDeviceSsdFill } from 'react-icons/bs'
import { MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";

/**
 * SmallAnlageCard
 * 
 * small and basic Anlage card, having only icon,
 * energo Anlagen number and address
 * 
 * used in: Timeline
 * 
 * @param {active} props bool is selected
 * @param {anlage} props object Anlage
 * @param {setSelected} props setter, set selected on click
 * @returns 
 */
const SmallAnlageCard = (props) => {

    const [hover, setHover] = useState("");
    const isSelected = props.active;
    const bg = isSelected? '#a2c13f':'white';
    const textColor = props.active? 'white':'black';
    const iconColor = props.active?  'text-light': props.anlage.x_studio_field_3eKe0 === "Strom"? "text-energo": props.anlage.x_studio_field_3eKe0 === "Gas"? "text-info": "text-warning";
    
    return (
            <Card
                onClick={() => props.setSelected(props.anlage.id)}
                className={`${hover}`}
                onMouseEnter={() => setHover("shadow-lg")}
                onMouseLeave={() => setHover("")}
                style={{backgroundColor: bg, color: textColor, width: "350px", marginRight: "10px", display: "inline-block"}}
            >
                <Card.Body>
                    <Row className="align-items-center">
                        <Col xs="12" xl="3">
                            <BsFillDeviceSsdFill size={30} className={iconColor} />
                        </Col>
                        <Col xs="12" xl="8">
                            <b className={iconColor}>
                            {props.anlage.x_studio_field_3eKe0 === "Strom"? 
                                <SlEnergy className={iconColor} />
                            : props.anlage.x_studio_field_3eKe0 === "Gas"?
                                <TbFlame className={iconColor} />
                            : props.anlage.x_studio_field_3eKe0 === "Strom-Einspeisung"?
                                <MdOutlineSolarPower className={iconColor} />
                            :null}
                                 &nbsp;Anlage {props.anlage.x_studio_field_mWMGR}</b>
                            <p>
                                <small style={{ fontSize: 12 }}>
                                    {
                                        props.anlage.x_studio_field_6T9W2 !== "False" || props.anlage.x_adresse_abw_top !== "False"?
                                            props.anlage.x_studio_field_6T9W2 !== "False" ? `Top ${props.anlage.x_studio_field_6T9W2}` :
                                            `Top ${props.anlage.x_adresse_abw_top}`
                                        :
                                        props.anlage.x_anlagenverwendung_detail !== "False"?
                                            props.anlage.x_anlagenverwendung_detail
                                        :
                                        props.anlage.x_anlagenverwendung !== "False" ?
                                            props.anlage.x_anlagenverwendung
                                        :
                                            "-"
                                    }
                                </small>
                                <br />
                                <small style={{ fontSize: 12 }}>{props.anlage.x_adresse_kompakt}</small>
                            </p>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

    )
}

export default SmallAnlageCard;